import { useNavigate } from 'react-router-dom'
import { Home, ArrowLeft, RefreshCw } from 'lucide-react'

export function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-primary-100 px-4">
      <div className="text-center max-w-2xl mx-auto">
        <div className="mb-8 relative">
          <div className="text-[180px] md:text-[220px] font-bold text-primary-200 leading-none select-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-6xl md:text-8xl">🔍</div>
          </div>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          页面未找到
        </h1>

        <p className="text-lg text-gray-600 mb-8 leading-relaxed">
          很抱歉，您访问的页面不存在或已被移除。<br />
          请检查URL是否正确，或返回首页继续浏览。
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 text-white font-medium rounded-lg transition-all duration-300 hover:bg-primary-600 hover:shadow-lg hover:shadow-primary-500/25 active:scale-95"
          >
            <Home size={20} />
            返回首页
          </button>

          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-white text-primary-500 font-medium rounded-lg border-2 border-primary-500 transition-all duration-300 hover:bg-primary-50 active:scale-95"
          >
            <ArrowLeft size={20} />
            返回上一页
          </button>

          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-gray-100 text-gray-700 font-medium rounded-lg transition-all duration-300 hover:bg-gray-200 active:scale-95"
          >
            <RefreshCw size={20} />
            刷新页面
          </button>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            需要帮助？请访问我们的
            <a href="/about" className="text-primary-500 hover:text-primary-600 mx-1">
              关于我们
            </a>
            或
            <a href="/cooperation" className="text-primary-500 hover:text-primary-600 ml-1">
              联系合作
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
